

















































































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";

export interface RegisterPayload {
  id: number;
  yj_code: string;
  start_date: string;
  end_date: string;
  remarks: string;
  updated_at: string;
}

interface ExistingData {
  id: number;
  start_date: string;
  end_date: string;
  remarks: string;
  updated_at: string;
}

@Component
export default class MedicineRegisterDialog extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ default: "" }) medicineName!: string;
  @Prop({ default: "" }) photoFileName!: string;
  @Prop({ default: "" }) yjCode!: string;
  /** 編集時にセットする既存データ（新規登録時はnull） */
  @Prop({ default: null }) existingData!: ExistingData | null;

  private internalValue = false;
  private startDate = "";
  private endDate = "";
  private remarks = "";

  get isEditMode(): boolean {
    return !!this.existingData;
  }

  @Watch("value")
  private onValueChanged(val: boolean) {
    this.internalValue = val;
    if (val) {
      if (this.existingData) {
        this.startDate = this.existingData.start_date || "";
        this.endDate = this.existingData.end_date || "";
        this.remarks = this.existingData.remarks || "";
      } else {
        this.startDate = "";
        this.endDate = "";
        this.remarks = "";
      }
    }
  }

  @Emit("input")
  private emitInput(val: boolean) {
    return val;
  }

  @Emit("save")
  private emitSave(payload: RegisterPayload) {
    return payload;
  }

  private close() {
    this.internalValue = false;
    this.emitInput(false);
  }

  private save() {
    this.emitSave({
      id: this.existingData ? this.existingData.id : 0,
      yj_code: this.yjCode,
      start_date: this.startDate,
      end_date: this.endDate,
      remarks: this.remarks,
      updated_at: this.existingData ? this.existingData.updated_at : ""
    });
    this.close();
  }
}
